import { authorizedFetch, baseUrl, removeEmpty } from './base';
import queryString from 'query-string';

async function listing(params = {}) {
  const path = `${baseUrl}/console/api/super_admin/monthly_credits?${queryString.stringify(
    removeEmpty(params)
  )}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function updateQuota(id, params = {}) {
  const path = `${baseUrl}/console/api/super_admin/monthly_credits/${id}/update_quota`;

  return await authorizedFetch(path, {
    method: 'PUT',
    body: JSON.stringify(params)
  });
}


const creditApis = { listing, updateQuota };

export default creditApis;
